var _ = { escape: require('lodash.escape') };
module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<ul class="gp-calendar__container__controls cf"><li class="gp-calendar__blurb"> ';
 if (autoAccept) { ;
__p += ' Booking Confirmed! ';
 } else { ;
__p += ' Booking Request Sent Successfully! ';
 } ;
__p += ' </li></ul><div class="booking-request-success-message"><p> ';
 if (autoAccept) { ;
__p += ' Booking confirmed. Please expect an email or SMS notification with appointment confirmation details. ';
 if ($("#page-data").data("instance-name") == 'vitality') { ;
__p += ' <br><strong>Remember to take your Discovery membership card and ID document with you.</strong><br><br> ';
 } ;
__p += ' ';
 if (['introcann', 'introcann_clinics'].includes($("#page-data").data("instance-name"))) { ;
__p += ' <br><strong>Please have a list of your current and previous medication prepared before your consult.</strong><br><br> ';
 } ;
__p += ' ';
 } else { ;
__p += ' Please wait for the&nbsp;<b>booking confirmation</b>&nbsp;e-mail or SMS from the practice. Please do not visit a practice that has not confirmed your appointment. ';
 if (['introcann', 'introcann_clinics'].includes($("#page-data").data("instance-name"))) { ;
__p += ' <br><strong>Please have a list of your current and previous medication prepared before your consult.</strong><br><br> ';
 } ;
__p += ' ';
 } ;
__p += ' </p><div><a href="' +
__e( $("#page-data").data("redirect") ) +
'" class="btn btn--border">OK</a></div></div>';

}
return __p
};

/*
original source:

<ul class="gp-calendar__container__controls cf">
    <li class="gp-calendar__blurb">
        <% if (autoAccept) { %>
            Booking Confirmed!
        <% } else { %>
            Booking Request Sent Successfully!
        <% } %>
</ul>
<div class="booking-request-success-message">
    <p>
        <% if (autoAccept) { %>
            Booking confirmed.
            Please expect an email or SMS notification with appointment confirmation details.
            <% if ($("#page-data").data("instance-name") == 'vitality') { %>
                <br />
                <strong>Remember to take your Discovery membership card and ID document with you.</strong>
                <br /><br />
            <% } %>
            <% if (['introcann', 'introcann_clinics'].includes($("#page-data").data("instance-name"))) { %>
                <br />
                <strong>Please have a list of your current and previous medication prepared before your consult.</strong>
                <br /><br />
            <% } %>
        <% } else { %>
            Please wait for the&nbsp;<b>booking confirmation</b>&nbsp;e-mail or SMS from the practice.
            Please do not visit a practice that has not confirmed your appointment.

            <% if (['introcann', 'introcann_clinics'].includes($("#page-data").data("instance-name"))) { %>
                <br />
                <strong>Please have a list of your current and previous medication prepared before your consult.</strong>
                <br /><br />
            <% } %>
        <% } %>
    </p>
    <div>
        <a href='<%- $("#page-data").data("redirect") %>' class="btn btn--border">OK</a>
    </div>
</div>

*/
